
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image className='bigImage' file={require('images/grafik_alkohol.jpg')} mdxType="Image" />
    <p>{`Er wird am häufigsten als Auslöser vermutet. Oft spielt aber nicht allein das
Getränk eine Rolle, sondern auch die Tageszeit. Manche Menschen vertragen
beispielsweise Sekt am Abend, am frühen Nachmittag aber löst er fast sicher eine
Migräne aus. Ähnliches gilt vermutlich auch für Nahrungsmittel: Es kommt auch
auf das Wann und Wie an. Wer sich an der Forschung zu den Auslösern von Migräne
beteiligen möchte, kann die «Mira – Kopfschmerz-Radar»-App herunterladen und
seine Anfallsdaten eingeben.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;